import noticeApi from '@/services/plataforma/notice';

export default {
  getNoticeByRole(_) {
    return noticeApi.getNoticeByRole()
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e));

  },
  getHighlightedNotice() {
    return noticeApi.getHighlightedNotice()
      .then((response) => {
        if (response.data?.renewed) {
          const signatureData = {
            shouldShowModal : response.data.shouldShowModal,
            expiredAt       : response.data.expiredAt,
            signature       : response.data.signature
          };
          localStorage.setItem('plataforma_noticeToken', JSON.stringify(signatureData));
        }
        return Promise.resolve(response.data);
      })
      .catch((e) => Promise.reject(e));
  },
  sendAgreedNotice({ commit }, data) {
    commit('SET_NOTICE_DISPLAYED');
    return noticeApi.sendAgreedNotice(data)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e));
  }
};
